import React from 'react'

class TutorialPage extends React.Component {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.location.href = '/article/measure-23-app-tutorial/';
    }
  }

  render() {
    return (<div>

    </div>)
  }

}

export default TutorialPage
